import { render } from "./PreviewPersonalDataFiles.vue?vue&type=template&id=03dc68a4"
import script from "./PreviewPersonalDataFiles.vue?vue&type=script&lang=js"
export * from "./PreviewPersonalDataFiles.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__